import InsightsApi from '@/api/insights.api'

const state = {
  sellerInsights: [],
}

function hasScheduleWithDemand(schedule) {
  if (!schedule?.length) return false
  return schedule.some(entry => entry.trafficSourceNames?.length > 0)
}

const getters = {
  getInsightsByOfferId: (state) => (sellerOfferId) => {
    if (!state.sellerInsights?.length) {
      return null
    }
    return state.sellerInsights.find(insight => insight.id === sellerOfferId) || null
  },

  hasOfferDemand: (state, getters) => (sellerOfferId) => {
    const insights = getters.getInsightsByOfferId(sellerOfferId)
    if (!insights) {
      return null // Unknown - insights not loaded
    }
    return hasScheduleWithDemand(insights.schedule)
  }
}

const actions = {
  async getSellerOfferInsights({ commit, getters }, sellerOfferId) {
    // Check if already in cache
    const existing = getters.getInsightsByOfferId(sellerOfferId)
    if (existing) {
      return existing
    }

    const response = await InsightsApi.getSellerOfferInsights(sellerOfferId)
    if (response.data) {
      commit('ADD_SELLER_OFFER_INSIGHT', response.data)
    }
    return response.data
  }
}

const mutations = {
  ADD_SELLER_OFFER_INSIGHT(state, insight) {
    if (!insight?.id) {
      return
    }
    // Check if already exists to avoid duplicates
    const exists = state.sellerInsights.some(i => i.id === insight.id)
    if (!exists) {
      state.sellerInsights.push(insight)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
